import React from 'react'
import { connect, batch } from 'react-redux';
import { Button, Dropdown, Icon, Table, Popconfirm, Divider, Tooltip, Row, Col, Typography, message } from 'antd';
import moment from 'moment-timezone';
import DragListView from 'react-drag-listview';
import { Icon as NeoIcon } from "@avaya/neo-react";
import {
    toggleBackButton,
    selectTitle,
    fetchNotifications,
    fetchActiveNotifications,
    toggleIsFetchingNotificationsFlag,
    putPushNotification,
    deleteNotification,
    clearNotifications,
    updateNotificationsCurrentPage,
    reorderNotifications,
    putNotificationsOrder,
    restoreNotification,
    fetchNotification,
    clearNotificationForm,
    refreshNotifications,
    toggleHasNotificationsUpdated,
    handleOnClickAction,
    clearNotificationsData,
    currentNotificationFilter,
    fetchDraftNotifications
} from '../../actions';
import CONFIG from '../../config';
import StatusFilter from '../common/StatusFilter';
import pushMessage from '../common/PushMessage';
import FilterPanel from '../common/FilterPanel';
import openConfirm from '../common/Confirm';
import scrollIntoView from 'scroll-into-view';
import { fetchNamesBySearchString } from '../../actions/userRole'
import { exportNewsNotificationTable } from "../../actions/news"
import { exportMenu } from "../../utils/strings";
import { isTabAlreadyOpen } from "../common/TabLayout";
const { Text } = Typography;
const dataIndexMap = {
    title: 'title',
    startTime: "startTime",
    updatedTime: "updatedTime",
    endTime: "endTime",
    applyToAllCheck: 'includeStartAndEndDate',
    viewDeletedItems: 'viewDeletedItems',
    createdBy: 'createdBy.fullName',
    updatedBy: 'updatedBy.fullName'
};
class ManageNotifications extends React.Component {
    constructor(props) {
        super(props);
        const that = this;
        this.dragProps = {
            onDragEnd(fromIndex, toIndex) {
                const newNotifications = that.props.activeNotifications;
                const item = newNotifications.splice(fromIndex, 1)[0];
                newNotifications.splice(toIndex, 0, item);
                that.props.reorderNotifications(newNotifications);
            },
            handleSelector: "i"
        };
        this.state = {
            inactiveNotificationsData: [],
            isReturnedFromEdit: false,
            previousStatus: true,
            isReturnedFromDelete: false,
            deletedRecordIndex: undefined,
            matchedUsersNames: [],
            showFilter: false
        }
        this.status = true;
        this.flag = 0;
    }
    tableRef = React.createRef();
    filter = undefined;
    currentPage = 1;
    activeFilterSort = {};
    inactiveFilterSort = {};
    draftFilterSort = {};
    fetchUsersName = searchString => {
        this.setState({ matchedUsersNames: [] });
        fetchNamesBySearchString({ searchString })
            .then((result) => {
                if (result?.length !== 0) {
                    delete result.id
                    this.setState({ matchedUsersNames: [...new Set(result.map(item => item.fullName))] })
                }
                this.setState({ hasEnteredString: false })
            });
    };
    async componentDidMount() {
        const { notifications, currentPageNumber } = this.props;
        document.getElementById('tab-pane').scrollIntoView();
        this.setState({ currentPath: window.location.pathname })
        if (notifications?.isEdit) {
            this.filter = notifications?.currentFilter;
            this.status = notifications?.status;
            this.activeFilterSort = notifications?.activeFilterSort || {}
            this.inactiveFilterSort = notifications?.inactiveFilterSort || {}
            this.draftFilterSort = notifications?.draftFilterSort || {}
            this.currentPage = currentPageNumber + 1 || 1
            this.status !== true && this.fetchNotificationsOnMount();
            if (notifications?.currentFilter && Object.keys(JSON.parse(JSON.stringify(notifications?.currentFilter)))?.length > 0) {
                const filterObject = JSON.parse(JSON.stringify(notifications?.currentFilter));
                Object.keys(filterObject)?.length > 0 && this.setState({ showFilter: true })
            }
        }
        batch(() => {
            this.props.selectTitle('Manage Notifications');
            this.props.toggleBackButton(false);
            this.props.toggleIsFetchingNotificationsFlag(true);
            this.props.fetchActiveNotifications(this.activeFilterSort);
            this.status === CONFIG.draftStatusDataSet[2].value && this.props.fetchDraftNotifications(this.draftFilterSort);
        });
    }
    fetchNotificationsOnMount = async () => {
        const { isEdit, pageSize, notificationsIndex } = this.props;
        this.props.toggleIsFetchingNotificationsFlag(true);
        this.setState({ loading: true })
        await this.props.fetchNotifications({
            pageNumber: (isEdit || this.state.isReturnedFromDelete) ? 1 : this.currentPage++,
            pageSize: (isEdit || this.state.isReturnedFromDelete) ? pageSize : CONFIG.lazyLoadPageSize,
            filterSort: this.inactiveFilterSort,
            status: this.status,
            fetchInactiveNotifications: true
        })
        if (this.props.response === CONFIG.HTTP_STATUS.OK || this.props.response === CONFIG.HTTP_STATUS.NO_CONTENT) {
            this.setState(({ inactiveNotificationsData }) => ({
                loading: false,
                inactiveNotificationsData: this.props.inactiveNotifications ? inactiveNotificationsData.concat(this.props.inactiveNotifications) : [],
                isReturnedFromEdit: isEdit && notificationsIndex !== undefined ? true : false,
            }))
        }
    }
    async componentDidUpdate() {
        if (this.status !== this.state.previousStatus) {
            await this.setState({ previousStatus: this.status })
            if (this.status === false || this.status === undefined) {
                var tableContent = document.querySelector(".inactive .ant-table-body");
                tableContent && tableContent.addEventListener('scroll', this.handleScroll)
            }
        }
        const notificationsToScrollIntoView = this.state.isReturnedFromDelete
            ? Math.abs(this.state.deletedRecordIndex - 1)
            : this.state.isReturnedFromEdit
                ? this.props.notificationsIndex
                : 0;
        (this.state.isReturnedFromEdit || this.state.isReturnedFromDelete)
            && this.props.inactiveNotifications?.length > 0
            && notificationsToScrollIntoView
            && scrollIntoView(document.querySelector(`.scroll-row-${notificationsToScrollIntoView}`), {
                align: { top: 0, left: 0 },
                behavior: "smooth"
            },
                this.setState({ isReturnedFromEdit: false, isReturnedFromDelete: false })
            )
    }
    handleScroll = (event) => {
        let maxScroll = event.target.scrollHeight - event.target.clientHeight
        let currentScroll = event.target.scrollTop
        if ((event.target.scrollTop + event.target.clientHeight >= event.target.scrollHeight - 100) && (currentScroll !== 0 && maxScroll !== 0)) {
            this.flag += 1;
            this.flag === 1 && this.handleFetch()
        }
    }
    handleFetch = async () => {
        const { inactiveNotificationsCount, inactiveNotifications } = this.props;
        const countOfRecordsFetched = inactiveNotifications?.length;
        if ((inactiveNotificationsCount === undefined && countOfRecordsFetched === undefined) || !(inactiveNotificationsCount < countOfRecordsFetched)) {
            this.props.toggleIsFetchingNotificationsFlag(true);
            await this.props.fetchNotifications({ pageNumber: this.currentPage++, pageSize: CONFIG.lazyLoadPageSize, fetchInactiveNotifications: true, filterSort: this.inactiveFilterSort })
                .then(() => {
                    if (this.props.response === CONFIG.HTTP_STATUS.OK || this.props.response === CONFIG.HTTP_STATUS.NO_CONTENT) {
                        this.setState(({ inactiveNotificationsData }) => ({
                            inactiveNotificationsData: this.props.inactiveNotifications ? inactiveNotificationsData.concat(this.props.inactiveNotifications) : [],
                            objectNotificationsCount: this.props.inactiveNotificationsCount
                        }))
                    }
                })
        }
        this.flag = 0;
    }
    async componentWillUnmount() {
        if (isTabAlreadyOpen({ openedTabs: this.props.openedTabs, currentComponentPath: this.state.currentPath })) {
            await this.props.currentNotificationFilter(this.activeFilterSort, this.inactiveFilterSort, this.draftFilterSort, this.filter, this.status)
            // This will ensure that we do not increment the pageNumber on Tab Switch.
            const nextPageNumber = this.currentPage > 2 ? this.currentPage - 1 : this.currentPage
            await this.props.updateNotificationsCurrentPage(nextPageNumber, (nextPageNumber * 12), 0, 0)
            await this.props.clearNotificationsData();
        } else {
            this.props.clearNotifications();
        }
    }
    handleCheckBoxToggle = (e, record) => {
        const { activeNotifications } = this.props;
        const flag = e.target.checked;
        const key = activeNotifications.find(notification => notification.id === record.id)
            ? "activeNotifications"
            : "inactiveNotifications";
        this.props.putPushNotification(record.id, flag, key)
    };
    handleDeleteConfirmation = async (index, isActive) => {
        const draftView = this.status === CONFIG.draftStatusDataSet[2].value;
        const notificationsIndex = isActive ? undefined : index
        const hardDelete = this.filter?.viewDeletedItems;
        const response = await this.props.deleteNotification(this.notificationId, draftView ? true : hardDelete, draftView)
        if (response) {
            this.handleFetchNotificationsAfterDeleteOrRestore(index, notificationsIndex, this.notificationId)
        }
    }
    handleFetchNotificationsAfterDeleteOrRestore = async (index, notificationsIndex, notificationId) => {
        if (this.status !== true) {
            this.clearCurrentNotifications();
            const pageSize = ((Math.ceil(index / CONFIG.lazyLoadPageSize) * CONFIG.lazyLoadPageSize) + CONFIG.lazyLoadPageSize);
            const currentPageNumber = ((Math.ceil(index / CONFIG.lazyLoadPageSize) * CONFIG.lazyLoadPageSize) / CONFIG.lazyLoadPageSize) + 1;
            await this.props.fetchActiveNotifications(this.activeFilterSort);
            await this.props.fetchDraftNotifications(this.draftFilterSort)
            await this.props.updateNotificationsCurrentPage(currentPageNumber, pageSize, notificationId, notificationsIndex);
            await this.setState({ isReturnedFromDelete: true, deletedRecordIndex: notificationsIndex })
            this.currentPage = this.props.currentPageNumber + 1
            this.fetchNotificationsOnMount();
        }
        else {
            this.clearCurrentNotifications();
            this.getNotifications();
        }
    }
    handleRestore = async (notificationId, index, isActive) => {
        const notificationsIndex = isActive ? undefined : index
        const response = await this.props.restoreNotification(notificationId)
        if (response) {
            this.handleFetchNotificationsAfterDeleteOrRestore(index, notificationsIndex, notificationId)
        }
    }
    handleDelete = (notificationId, index, isActive) => {
        const draftView = this.status === CONFIG.draftStatusDataSet[2].value;
        this.notificationId = notificationId;
        const hardDelete = this.filter?.viewDeletedItems;
        if (this.props.userProfile?.isDeveloper && hardDelete) pushMessage(CONFIG.messageType.warning, CONFIG.warningMessages.forbidden)
        else {
            const okButtonText = (hardDelete || draftView) ? "Confirm Permanent Deletion" : "Confirm Deletion"
            const content = (hardDelete || draftView) ? <h4>{CONFIG.warningMessages.hardDelete.replace("<placeHolder>", "Notification")}</h4> : <h4>{CONFIG.warningMessages.softDelete.replace("<placeHolder>", "Notification")}</h4>
            const modalTitle = CONFIG.deleteModalTitle?.replace('<placeholder>', draftView ? 'Notification Draft' : 'notification');
            openConfirm(okButtonText, () => this.handleDeleteConfirmation(index, isActive), null, content, modalTitle);
        }
    }
    getUTCTime = (time) => {
        const { timeZoneName } = this.props;
        return time.tz(timeZoneName, true).toISOString();
    }
    clearCurrentNotifications = () => {
        this.currentPage = 1
        this.setState({
            inactiveNotificationsData: []
        })
    }
    getNotifications = () => {
        this.activeFilterSort = { ...this.activeFilterSort, filter: this.filter }
        this.inactiveFilterSort = { ...this.inactiveFilterSort, filter: this.filter }
        this.draftFilterSort = { ...this.draftFilterSort, filter: this.filter }
        batch(async () => {
            this.props.clearNotifications();
            this.props.toggleIsFetchingNotificationsFlag(true);
            if (this.status === true)
                this.props.fetchActiveNotifications(this.activeFilterSort).catch((error) => pushMessage(CONFIG.messageType.error, error.message))
            else if (this.status === false) this.handleFetch()
            else if (this.status === CONFIG.draftStatusDataSet[2].value) {
                this.props.fetchDraftNotifications(this.draftFilterSort);
            }
            else {
                await this.props.fetchActiveNotifications(this.activeFilterSort)
                this.handleFetch()
            }
        })
    }
    handleFilter = async (filters) => {
        let { title, startEndTime, applyToAllCheck, viewDeletedItems, createdBy, updatedBy } = filters;
        await this.clearCurrentNotifications();
        title = title?.trim();
        const isStartEndTimeEmpty = !startEndTime || (startEndTime && startEndTime.length === 0);
        if (!title && isStartEndTimeEmpty && !viewDeletedItems && !createdBy && !updatedBy) {
            pushMessage(CONFIG.messageType.warning, "Please select some fields to filter")
            return;
        }
        if (viewDeletedItems) this.status = undefined
        this.filter = {
            [dataIndexMap.title]: title || undefined,
            [dataIndexMap.startTime]: !isStartEndTimeEmpty ? this.getUTCTime(startEndTime[0]) : undefined,
            [dataIndexMap.endTime]: !isStartEndTimeEmpty ? this.getUTCTime(startEndTime[1]) : undefined,
            [dataIndexMap.applyToAllCheck]: applyToAllCheck || undefined,
            [dataIndexMap.viewDeletedItems]: viewDeletedItems,
            [dataIndexMap.createdBy]: createdBy || undefined,
            [dataIndexMap.updatedBy]: updatedBy || undefined
        }
        this.getNotifications();
        scrollIntoView(document.querySelector(`.ant-table-thead`), {
            align: { top: 10, left: 0 },
            behavior: "smooth"
        })
    }
    handleClear = (refresh) => {
        if (refresh) {
            this.props.refreshNotifications();
            this.currentPage = 1;
            this.props.toggleHasNotificationsUpdated(false);
        }
        else {
            this.setState({ matchedUsersNames: [] })
            this.clearCurrentNotifications();
            this.filter = undefined;
            this.activeFilterSort = { ...this.activeFilterSort, filter: undefined };
            this.inactiveFilterSort = { ...this.inactiveFilterSort, filter: undefined }
            this.draftFilterSort = { ...this.draftFilterSort, filter: undefined };
        }
        this.getNotifications();
    }
    handleChange = async (status, pagination, _, sorter) => {
        const type = status ? "activeFilterSort" : "inactiveFilterSort"
        this.props.clearNotifications()
        await this.clearCurrentNotifications();
        this[type] = {
            ...this[type],
            sort: sorter.columnKey
                ? {
                    [sorter.columnKey]: CONFIG.sortMap[sorter.order]
                }
                : undefined
        }
        this.getNotifications();
    }
    renderUpdateButton = () => {
        const isUpdateDisabled = !this.isTableSorted || this.filter !== undefined || this.props.activeNotifications?.length === 0;
        const deleteView = this.filter?.viewDeletedItems;
        return !deleteView && (
            <Button className="primary-action-button-bordered"
                disabled={!this.props.isReordered && isUpdateDisabled}
                onClick={() => this.props.putNotificationsOrder(this.props.activeNotifications)}
            >
                Update order
            </Button>
        );
    }
    handleSelectChange = async (value) => {
        var tableContent = document.querySelector(".inactive .ant-table-body");
        tableContent && tableContent.removeEventListener('scroll', this.handleScroll)
        this.status = value;
        await this.clearCurrentNotifications();
        if (value) this.inactiveFilterSort = { ...this.inactiveFilterSort, sort: undefined }
        else if (value === false) this.activeFilterSort = { ...this.activeFilterSort, sort: undefined }
        else if (value === CONFIG.draftStatusDataSet[2].value) this.draftFilterSort = { ...this.draftFilterSort, sort: undefined }
        batch(() => {
            this.props.clearNotifications();
            this.props.toggleIsFetchingNotificationsFlag(true);
            this.getNotifications();
        })
    }
    handleExport = async (fileType) => {
        const timeZone = this.props.timeZoneName;
        pushMessage(CONFIG.messageType.loading, "Exporting", 0);
        exportNewsNotificationTable(CONFIG.exportTable.notifications.name, CONFIG.exportTable.notifications.fileName + `.${fileType}`, fileType, this.activeFilterSort, this.status, timeZone)
            .then((response) => {
                message.destroy()
                const isExport = response.status === CONFIG.HTTP_STATUS.OK
                pushMessage(isExport ? CONFIG.messageType.success : CONFIG.messageType.warning, isExport ? "Table exported successfully" : "There is no data to export. Please verify the filters")
            })
            .catch(() => {
                message.destroy()
                pushMessage(CONFIG.messageType.error, "Unable to export table")
            })
    }
    render() {
        const { activeNotifications, userRoleTemplate, isFetching, timeZoneName, inactiveNotificationsCount, inactiveNotifications, draftNotifications } = this.props;
        const isUserSuperAdmin = userRoleTemplate.templateType === CONFIG.roleTypes.superAdmin;
        this.isTableSorted = this.activeFilterSort?.sort ? Object.keys(this.activeFilterSort?.sort)?.filter(key => this.activeFilterSort?.sort[key] !== undefined)?.length !== 0 : false;
        const isDragDisabled = this.filter !== undefined;
        const deleteView = this.filter?.viewDeletedItems;
        const adminColumns = [
            {
                title: "",
                key: "operate",
                align: 'center',
                render: () => <Icon aria-label="aria-menu" className="drag-handle" type="drag" />,
                width: 50
            }
        ]

        const draftNotificationColumns = isUserSuperAdmin ? [
            {
                title: <span className={this.filter?.[dataIndexMap.updatedTime] ? "filtered-column" : ''}>Last Modified on</span>,
                dataIndex: 'updatedTime',
                key: 'updatedTime',
                align: 'center',
                width: 200,
                render: (updatedTime) => updatedTime ? moment.tz(updatedTime, this.props.timeZoneName).format(CONFIG.dateFormats.userDateTime) : "-",
                sorter: true
            },
            {
                title: <span className={this.filterSort?.filter?.[dataIndexMap.createdBy] ? "filtered-column" : ''}>Created By</span>,
                key: "createdBy.fullName",
                dataIndex: "createdBy",
                sorter: true,
                width: 200,
                render: (createdBy) => createdBy ? createdBy?.fullName : "-",
            },
        ] : [{
            title: <span className={this.filter?.[dataIndexMap.updatedTime] ? "filtered-column" : ''}>Last Modified on</span>,
            dataIndex: 'updatedTime',
            key: 'updatedTime',
            align: 'center',
            width: 200,
            render: (updatedTime) => updatedTime ? moment.tz(updatedTime, this.props.timeZoneName).format(CONFIG.dateFormats.userDateTime) : "-",
            sorter: true
        }]

        const columns = [
            {
                title: 'No.',
                key: 'index',
                align: 'center',
                width: 75,
                render: (text, record, index) => index + 1,
            },
            {
                title: <span className={this.filter?.[dataIndexMap.title] ? "filtered-column" : ''}>Title</span>,
                dataIndex: 'title',
                key: 'title',
                width: 300,
                sorter: true
            },
            {
                title: <span className={this.filter?.[dataIndexMap.startTime] ? "filtered-column" : ''}>Start Date</span>,
                dataIndex: 'validityStartTime',
                key: 'validityStartTime',
                align: 'center',
                width: 200,
                render: (startTime) => moment.tz(startTime, this.props.timeZoneName).format(CONFIG.dateFormats.userDateTime),
                sorter: true
            },
            {
                title: <span className={this.filter?.[dataIndexMap.endTime] ? "filtered-column" : ''}>End Date</span>,
                dataIndex: 'validityEndTime',
                key: 'validityEndTime',
                align: 'center',
                width: 200,
                render: (endTime) => moment.tz(endTime, this.props.timeZoneName).format(CONFIG.dateFormats.userDateTime),
                sorter: true
            },
            {
                title: <span className={this.filterSort?.filter?.[dataIndexMap.createdBy] ? "filtered-column" : ''}>Created By</span>,
                key: "createdBy.fullName",
                dataIndex: "createdBy",
                sorter: true,
                width: 200,
                render: (createdBy) => createdBy ? createdBy?.fullName : "-",
            },
            {
                title: <span className={this.filterSort?.filter?.[dataIndexMap.updatedBy] ? "filtered-column" : ''}>Updated By</span>,
                key: "updatedBy.fullName",
                dataIndex: "updatedBy",
                sorter: true,
                width: 200,
                render: (updatedBy) => updatedBy ? updatedBy?.fullName : "-",
            },
            {
                title: 'Action',
                key: 'action',
                align: 'center',
                width: 150,
                fixed: 'right',
                render: (text, record, index) => {
                    const isEditDisabled = userRoleTemplate && userRoleTemplate.templateType !== CONFIG.roleTypes.superAdmin && record.adminAccess === CONFIG.roleTemplateAccess.readOnly
                    const isCloneDisabled = (userRoleTemplate && userRoleTemplate.templateType !== CONFIG.roleTypes.superAdmin && record.adminAccess === CONFIG.roleTemplateAccess.readOnly)
                    const draftView = this.status === CONFIG.draftStatusDataSet[2].value;

                    return (
                        <React.Fragment>
                            {!deleteView &&
                                <>
                                    <Tooltip title={isEditDisabled ? CONFIG.warningMessages.noAccess : undefined} key={record.id}>
                                        <button
                                            onClick={async () => {
                                                await this.props.handleOnClickAction({
                                                    component: draftView ? CONFIG.draftEditComponentRoute.notification : CONFIG.editComponentRoute.notifications,
                                                    tabTitle: record?.title ? record?.title : "",
                                                    recordId: record?.id
                                                })
                                            }}
                                            id='manage-notification-edit'
                                            disabled={isEditDisabled} className={!isEditDisabled ? "link" : "link-disabled"}>
                                            <span class="neo-icon-edit" title="Edit" style={{ fontSize: "20px" }}></span>
                                        </button>
                                    </Tooltip>
                                </>
                            }
                            {!deleteView && !draftView &&
                                <>
                                    <Divider type="vertical" />
                                    <Tooltip title={isCloneDisabled ? CONFIG.warningMessages.noAccess : undefined} key={record.id}>
                                        <Tooltip title={isCloneDisabled ? CONFIG.warningMessages.noAccess : undefined} key={record.id}>
                                            < button
                                                onClick={async () => {
                                                    await this.props.handleOnClickAction({
                                                        component: CONFIG.cloneComponentRoute.notifications,
                                                        tabTitle: record?.title,
                                                        recordId: record?.id,
                                                        isClone: true
                                                    })
                                                }}
                                                id='manage-notification-clone'
                                                disabled={isCloneDisabled}
                                                className={!isCloneDisabled ? "link" : "link-disabled"}>
                                                <span class="neo-icon-copy" title="Clone" style={{ fontSize: "20px" }}></span>
                                            </button>
                                        </Tooltip>
                                    </Tooltip>
                                </>
                            }
                            {!deleteView && <Divider type="vertical" />}

                            <Tooltip title={isEditDisabled ? CONFIG.warningMessages.noAccess : undefined} key={record.id}>
                                {
                                    <>
                                        <button disabled={isEditDisabled} id='manage-notification-delete' className={!isEditDisabled ? "link" : "link-disabled"} onClick={() => this.handleDelete(record.id, index + 1, record?.isActive)}><span class="neo-icon-trash" title="Delete" style={{ fontSize: "20px" }}></span></button>
                                        {deleteView && <>
                                            <Divider type="vertical" />
                                            <Popconfirm disabled={isEditDisabled} title="Confirm restore?" onConfirm={() => this.handleRestore(record.id, index + 1, record?.isActive)}>
                                                <button disabled={isEditDisabled} id='manage-notification-restore' className={!isEditDisabled ? "link" : "link-disabled"}><span class="neo-icon-history" title="Restore" style={{ fontSize: "20px" }}></span></button>
                                            </Popconfirm>
                                        </>
                                        }
                                    </>
                                }
                            </Tooltip>
                        </React.Fragment>
                    );
                }
            }
        ];
        const formFields = [
            {
                label: "Title",
                type: CONFIG.formFieldTypes.INPUT,
                key: "title",
                colSpan: 8,
                value: this.filter?.title
            },
            {
                label: "Created By",
                type: CONFIG.formFieldTypes.SEARCH_SELECT,
                key: "createdBy",
                data: this.state.matchedUsersNames,
                colSpan: 8,
                value: this.filter?.[dataIndexMap?.createdBy]
            },
            {
                label: "Updated By",
                type: CONFIG.formFieldTypes.SEARCH_SELECT,
                key: "updatedBy",
                data: this.state.matchedUsersNames,
                colSpan: 8,
                value: this.filter?.[dataIndexMap?.updatedBy]
            },
            {
                label: "Start / End Date",
                type: CONFIG.formFieldTypes.RANGE_PICKER,
                key: "startEndTime",
                colSpan: 16,
                value: [this.filter?.startTime, this.filter?.endTime, this.filter?.includeStartAndEndDate]
            }
        ]
        const { showFilter } = this.state;
        return (
            <React.Fragment>
                <Row>
                    <Col xl={3} sm={6} xs={24}>
                        <StatusFilter disabled={this.filter?.viewDeletedItems} dataSet={CONFIG.draftStatusDataSet} onChange={this.handleSelectChange} value={this.status} />
                    </Col>
                    <Col xl={2} sm={6} xs={24} className="left-spacing">
                        <Button className="primary-action-button-filled"
                            id='manage-notification-create'
                            onClick={async () => {
                                await this.props.handleOnClickAction({
                                    component: CONFIG.createComponentRoute.notifications,
                                    tabTitle: "Create"
                                })
                            }}>New
                            <Icon aria-label="aria-menu" type="plus-circle" />
                        </Button>
                    </Col>
                    <Col xl={1} sm={2} xs={2} className="float-right">
                        <Dropdown overlay={exportMenu(this.handleExport)} trigger="click">
                            <NeoIcon aria-label="menu-aria" title="Export" icon="download" style={{ fontSize: "23px", color: '#0b67bd' }} id='manage-export-notification' />
                        </Dropdown>
                    </Col>
                    <Col xl={1} sm={2} xs={2} className="float-right">
                        <NeoIcon aria-label="menu-aria" className="clickable" title="Refresh" icon="refresh" onClick={() => this.handleClear(true)} style={{ fontSize: "23px", color: '#0b67bd' }} id='manage-refresh-notification' />
                    </Col>
                    <Col xl={1} sm={2} xs={2} className="float-right">
                        <NeoIcon aria-label="menu-aria" className="clickable" onClick={() => this.setState(prevState => ({
                            showFilter: !prevState.showFilter
                        }))} title="Filter" icon={showFilter ? "filter-filled" : "filter"} style={{ fontSize: "23px", color: '#0b67bd' }} id='manage-filter-notification' />
                    </Col>
                </Row>
                <Row>
                    <Col>
                        {this.state.showFilter &&
                            <FilterPanel
                                label='View Deleted Notifications'
                                panelHeader="Filters and Export"
                                formFields={(this.status === CONFIG.draftStatusDataSet[2].value) ? formFields.slice(0, 2) : formFields}
                                handleClear={this.handleClear}
                                handleFilter={this.handleFilter}
                                getSearchData={this.fetchUsersName}
                                timeZone={timeZoneName}
                                hideSoftDeleteCheckbox={(this.status === CONFIG.draftStatusDataSet[2].value) ? true : false}
                                viewDeletedItemsValue={deleteView}
                            />}
                    </Col>
                </Row>
                {(this.status === undefined || this.status === true) &&
                    <Row>
                        <div className="content-container responsive-container" id='notification-table'>
                            <h3>{this.filter?.viewDeletedItems ? 'Deleted Active Notifications' : 'Active Notifications'}</h3>
                            <div ref={(this.status === undefined || this.status) ? this.tableRef : undefined}>
                                {isUserSuperAdmin && this.renderUpdateButton()}
                                <DragListView {...this.dragProps}>
                                    <Table
                                        size='middle'
                                        className="vertical-spacing responsive-container active"
                                        rowKey={(record) => record.id}
                                        bordered
                                        dataSource={activeNotifications}
                                        columns={(isUserSuperAdmin && isDragDisabled === false) ? [...adminColumns, ...columns] : columns}
                                        loading={isFetching}
                                        pagination={false}
                                        scroll={{ y: 550, x: "auto" | 800 }}
                                        onChange={(...rest) => this.handleChange(true, ...rest)}
                                    />
                                </DragListView>
                                {isUserSuperAdmin && this.renderUpdateButton()}
                                <br />
                                <br />
                            </div>
                        </div>
                    </Row>
                }
                {(this.status === undefined || this.status === false) &&

                    <div >
                        <Row>
                            <div className={"content-container responsive-container"} ref={this.status === false ? this.tableRef : undefined}>
                                <h3>{this.filter?.viewDeletedItems ? 'Deleted Inactive Notifications' : 'Inactive Notifications'}</h3>
                                <Table
                                    size='middle'
                                    className="responsive-container inactive"
                                    rowClassName={(record, index) => (`scroll-row-${index + 1}`)}
                                    rowKey={(record) => record.id}
                                    bordered
                                    dataSource={inactiveNotifications}
                                    columns={columns}
                                    loading={isFetching}
                                    onChange={(...rest) => this.handleChange(false, ...rest)}
                                    pagination={false}
                                    scroll={{ y: 550, x: "true" | 800 }}
                                    footer={() => <>{inactiveNotifications?.length !== 0 && <div style={{ textAlign: 'center' }}>
                                        <Text strong>Fetched {inactiveNotifications?.length} out of {inactiveNotificationsCount} inactive Notifications</Text>
                                    </div>}
                                    </>}
                                />
                            </div>
                        </Row>
                    </div>
                }
                {(this.status === CONFIG.draftStatusDataSet[2].value) &&
                    <div >
                        <Row>
                            <div className={"content-container responsive-container"} ref={this.status === CONFIG.draftStatusDataSet[2].value ? this.tableRef : undefined}>
                                <h3>{'Draft Notifications'}</h3>
                                <Table
                                    size='middle'
                                    className="responsive-container inactive"
                                    rowClassName={(record, index) => (`scroll-row-${index + 1}`)}
                                    rowKey={(record) => record.id}
                                    bordered
                                    dataSource={draftNotifications}
                                    columns={[...columns.slice(0, 2), ...draftNotificationColumns, ...columns.slice(-1)]}
                                    loading={isFetching}
                                    onChange={(...rest) => this.handleChange(false, ...rest)}
                                    pagination={false}
                                    scroll={{ y: 550, x: "true" | 800 }}
                                />
                            </div>
                        </Row>
                    </div>
                }
            </React.Fragment>
        )
    }
}
const mapStateToProps = ({ user, notifications, viewport, tabsLayout }) => {
    return {
        userProfile: user.profile,
        timeZoneName: user.profile ? user.profile.timezone : undefined,
        userRoleTemplate: user.profile ? user.profile.roleTemplate : undefined,
        viewport,
        currentPage: notifications.currentPage,
        isFetching: notifications.isFetching,
        count: notifications.count,
        activeNotifications: notifications.activeNotifications,
        inactiveNotifications: notifications.inactiveNotifications,
        draftNotifications: notifications.draftNotifications,
        isReordered: notifications.isReordered,
        inactiveNotificationsCount: notifications.inactiveNotificationsCount,
        isEdit: notifications.isEdit,
        currentNotificationsId: notifications.currentNotificationsId,
        notificationsIndex: notifications.notificationsIndex,
        currentPageNumber: notifications.currentPageNumber,
        pageSize: notifications.pageSize,
        notifications,
        response: notifications.response,
        openedTabs: tabsLayout.panes,
    };
};
export default connect(
    mapStateToProps,
    {
        toggleBackButton,
        selectTitle,
        fetchNotifications,
        toggleIsFetchingNotificationsFlag,
        putPushNotification,
        deleteNotification,
        clearNotifications,
        updateNotificationsCurrentPage,
        fetchActiveNotifications,
        reorderNotifications,
        putNotificationsOrder,
        restoreNotification,
        fetchNotification,
        clearNotificationForm,
        refreshNotifications,
        toggleHasNotificationsUpdated,
        handleOnClickAction,
        clearNotificationsData,
        currentNotificationFilter,
        fetchDraftNotifications
    }
)(ManageNotifications);